module.exports = __webpack_public_path__ + "static/media/4.b8bf4abb.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/4.JPG
// module id = 474
// module chunks = 0